const LOCALE_MAP: Record<string, string> = {
  en: 'en-US',
  it: 'it-IT',
};

export const resolveIntlLocale = (language: string): string => {
  const normalized = language.split('-')[0]?.toLowerCase() ?? 'en';
  return LOCALE_MAP[normalized] ?? language;
};

export const formatLocaleNumber = (value: number, language: string): string =>
  new Intl.NumberFormat(resolveIntlLocale(language), { maximumFractionDigits: 0 }).format(value);
